import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=385a2c7e"
import script from "./Certificates.vue?vue&type=script&lang=ts"
export * from "./Certificates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports